import React from "react";

const PushNotification: React.FC = () => {
    let apiUrl = 'http://localhost:4000';
    if (process.env.NODE_ENV === 'production') {
        if (window.location.hostname.indexOf('local') !== -1) {
            apiUrl = 'https://experientiel-backend.ddev.site';
        } else {
            apiUrl = 'https://experientiel-backend.techniconcept.dev'
        }
    }

    const sendNotification = async () => {

        try {
            const token = localStorage.getItem('fcmToken');
            const title = 'My notification'
            const body = 'Notification body'

            const response = await fetch(apiUrl + '/send-notification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({token, title, body}),
            });

            const data = await response.json();
            console.log('Notification sent:', data);
        } catch (error) {
            console.error('Error sending notification:', error);
        }
    }

    const sendDelayedNotification = async () => {
        try {
            const token = localStorage.getItem('fcmToken');
            const title = 'My delayed notification'
            const body = 'Delayed notification body'

            const response = await fetch(apiUrl + '/send-delayed-notification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({token, title, body}),
            });

            const data = await response.json();
            console.log('Delayed notification sent:', data);
        } catch (error) {
            console.error('Error sending delayed notification:', error);
        }
    }

    return (
        <div style={{marginTop: '40px'}}>
            <button onClick={sendNotification} style={{marginRight: '20px'}}>Send Notification</button>
            <button onClick={sendDelayedNotification}>Send Delayed Notification</button>
        </div>
    )
}

export default PushNotification
